module.exports = __webpack_public_path__ + "media/dom/bghead-8f9bb2f1.png";